<template>
  <UserLayout>
    <section class="mb-4">
      <img
        class="object-cover w-full rounded-lg"
        :src="require('@/assets/img/session-list-banner.jpg')"
        alt="..."
        style="height: 40vh"
      />
    </section>
    
    <section>
      <h6 class="text-xl font-semibold leading-normal mt-0 mb-4 text-gray-dark">
        My Upcoming Clasess
      </h6>
      <section 
        class="md:mb-20 mb-8 gap-4"
        v-if="userUpcomingSessionsData && userUpcomingSessionsData.length"
      >
         <UpcomingSessionsCard
            :data="userUpcomingSessionsData && userUpcomingSessionsData"
          />
      </section>
      <div v-else>
        <p>No data found</p>
      </div>
      <Pagination
        v-if="userUpcomingSessionsData.length"
        :currentPage="currentPage"
        :handlePageChange="handlePageChange"
        :totalPages="totalPages"
      />
    </section>
  </UserLayout>
</template>

<script>
import UserLayout from "@/components/layouts/UserLayout";
import UpcomingSessionsCard from "@/components/UpcomingSessionsCard";
import { Pagination } from "@/components/t-components";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "UserSessions",
  components: {
    UserLayout,
    UpcomingSessionsCard,
    Pagination,
  },
  data() {
    return {
      userUpcomingSessionsData: [],
      currentPage: 1,
      totalPages: "",
      showDateTime: false,
    };
  },
  computed: {
    ...mapGetters(["userUpcomingSessions"]),
  },
  methods: {
    ...mapActions(["getUserUpcomingSessions"]),

    async handlePageChange(page) {
      this.currentPage = page;
      const query = {
        page,
      };
      this.userUpcomingSessionsData = [];
      await this.getUserUpcomingSessions({ query });
      
      this.userUpcomingSessionsData =
        (this.userUpcomingSessions.data &&
          this.userUpcomingSessions.data) ||
        [];
    },
  },
  async created() {
    const query = {
      page: this.currentPage,
    };
    await this.getUserUpcomingSessions({ query });

    // console.log(this.userUpcomingSessions.data);

    this.userUpcomingSessionsData =
      (this.userUpcomingSessions.data && this.userUpcomingSessions.data) ||
      [];
    this.totalPages =
      this.userUpcomingSessions.data &&
      this.userUpcomingSessions.data.last_page;
  },
};
</script>